import {AbstractEvent} from "@/modules/base/events";

export default class AfterDatabasePreparedEvent extends AbstractEvent
{

}